export function WhatAreSmallApartmentBuildings() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              What Are Small Apartment Buildings?
            </h2>
            <p className="text-lg text-gray-600 mb-6">
              Small apartment buildings, also known as small multifamily properties, typically consist of 2 to 5 residential units within a single structure or on a single property. These properties represent an excellent entry point into real estate investing and are popular among both first-time investors and experienced property owners looking to diversify their portfolios.
            </p>
            <p className="text-lg text-gray-600 mb-6">
              The most common types of small apartment buildings include duplexes (2 units), triplexes (3 units), quadplexes or fourplexes (4 units), and five-unit apartment buildings. Each configuration offers unique advantages and challenges for property owners, but all share the benefit of generating multiple income streams from a single property investment.
            </p>
            <p className="text-lg text-gray-600">
              These properties are often found in residential neighborhoods and can range from older, traditional structures built in the early to mid-20th century to modern, newly constructed buildings with contemporary amenities. Regardless of age or condition, small apartment buildings remain a cornerstone of the American rental housing market.
            </p>
          </div>
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/d03de8ebf1b09b99cf44ea63dda1ac01.jpg"
              alt="Small Apartment Building Example"
              className="w-full h-full object-cover rounded-xl shadow-2xl"
            />
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="bg-amber-50 p-6 rounded-xl">
            <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-home-2-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Duplexes</h3>
            <p className="text-gray-600">
              Two-unit properties that share a common wall or are stacked vertically. Perfect for owner-occupants who want to live in one unit while renting the other to offset mortgage costs.
            </p>
          </div>

          <div className="bg-amber-50 p-6 rounded-xl">
            <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-building-2-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Triplexes</h3>
            <p className="text-gray-600">
              Three-unit buildings offering increased rental income potential while still maintaining a manageable property size. Often configured with one unit per floor or side-by-side arrangements.
            </p>
          </div>

          <div className="bg-amber-50 p-6 rounded-xl">
            <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-community-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Quadplexes</h3>
            <p className="text-gray-600">
              Four-unit properties that maximize rental income while still qualifying for residential financing in many cases. Popular among investors seeking strong cash flow from a single property.
            </p>
          </div>

          <div className="bg-amber-50 p-6 rounded-xl">
            <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-building-4-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">5-Unit Buildings</h3>
            <p className="text-gray-600">
              Five-unit apartment buildings that bridge the gap between small multifamily and commercial properties. Offer excellent income potential with diversified tenant base.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}